import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page9() {
  useEffect(() => {
    document.title = "Маяк — Страница 18"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page17" />
        <ForwardLink href="/page19" />
      </div>

      <p style={{ textAlign: "right" }}>18.</p>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НОЧЬ</p>
      <p>Опять скрод и картошка.</p>
      <p>У МОЛОДОГО вода. СТАРИК наливает себе немного спиртного.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Пусть смерть бледная с тройным ужасом<br/>
        сделает океанские пещеры нашей могилой,<br/>
        Бог, который слышит раскаты волн,<br/>
        соблаговоли спасти просящую душу.
      </p>
      <p>
        Они выпивают. МОЛОДОЙ немного вздрогнул. СТАРИК доволен<br/>
        и начинает есть.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        (жуя)<br/>
        Все еще чувствуется вкус головы?
      </p>
      <p>МОЛОДОЙ не кивает.</p>
      <p>Они едят в тишине.</p>
      <p>СТАРИК поднимает взгляд на МОЛОДОГО... МОЛОДОЙ его игнорирует.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Аx, будь немного повеселее, парень. Сейчас<br/>
        время для сплетен и болтовни.<br/>
        Лучше наслаждайся этим. Пройдет две недели,<br/>
        и нам захочется молчать<br/>
        как в могиле.<br/>
        И даже смотреть друг<br/>
        на друга не сможем... Тебе станет жарче, чем<br/>
        в аду!
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я не слишком болтлив.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Думаешь, ты первый?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, сэр. Не думаю.
      </p>
      <p style={{ textAlign: "center" }}  >
        СТАРИК<br/>
        Нет. Нет. Да,<br/>
        Чикопи, шикарной она была.<br/>
        Аккуратной и стройной!<br/>
        В 64-м больше судна не было, чем она... Мы<br/>
        были на переправах -- был бунт.<br/>
        И почему, спросишь ты? Почему?<br/>
        Какая ужасная часть жизни моряка<br/>
        беспокоит тебя, парень?<br/>
        Вы не правы, капитан, заставляя их<br/>
        работать не покладая рук. Нет, нет.<br/>
        (ДАЛЕЕ)
      </p>
      <p style={{ textAlign: "right" }}>18.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page17" />
        <ForwardLink href="/page19" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708111494/the-lighthouse-script/jnom7bz4scnu2qleotmx.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page9;
